import service from "../../request/request"
export function get_customer_list(name, page, size) {
    return service({
        url: "/api/cloudwatch/get_car_vendor",
        method: 'POST',
        data: {
            row: {
                name: '',
                page: 1,
                size: 5,
            }
        }

    })
}
export function get_car_data() {
    return service({
        url: "/api/cloudwatch/get_car_data",
        method: 'POST',
    })
}

export function get_status_number() {
    return service({
        url: "/api/cloudwatch/total_mileage",
        method: 'POST',
    })
}
export function get_car_status(code) {
    return service({
        url: "/api/cloudwatch/equipment_state",
        method: 'POST',
    
    })
}
export function while_traveling() {
    return service({
        url: "/api/cloudwatch/while_traveling",
        method: 'POST',
    })
}
export function get_car_gps() {
    return service({
        url: "/api/cloudwatch/get_gps_list",
        method: 'POST',
    })
}

export function get_bug_list(vin,page,size) {
    return service({
        url: "/api/cloudwatch/alert_mode",
        method: 'POST',
        data: {
            row: {
                vin:vin,
                page:page,
                size:size,
            }
        }
    })
}
export function alert_count() {
    return service({
        url: "/api/cloudwatch/alert_count",
        method: 'POST',

    })
}
export function get_car_online_total() {
    return service({
        url: "/api/cloudwatch/vehicle_online_statistics",
        method: 'POST',

    })
}
export function time_sharing_mileage() {
    return service({
        url: "/api/cloudwatch/time_sharing_mileage",
        method: 'POST',

    })
}
export function electricity_consumption() {
    return service({
        url: "/api/cloudwatch/electricity_consumption",
        method: 'POST',
    })
}
export function driving_mode() {
    return service({
        url: "/api/cloudwatch/driving_mode",
        method: 'POST',
    })
}

export function deal_alert(id,note) {
    return service({
        url: "/api/cloudwatch/batch_alert",
        method: 'POST',
        data: {
            row: {
                ids: id,
                note:note
            }
        }
    })
}
export function ignore_alert(id) {
    return service({
        url: "/api/cloudwatch/ignore_alert",
        method: 'POST',
        data: {
            row: {
                id: id,
            }
        }
    })
}

export function latest_new_vehicle_record() {
    return service({
        url: "/api/cloudwatch/latest_new_vehicle_record",
        method: 'POST',
    })
}

//故障统计
export function hourly_fault() {
    return service({
        url: "/api/cloudwatch/hourly_fault",
        method: 'POST',
    })
}

//全部忽略
export function ignore_all() {
    return service({
        url: "/api/cloudwatch/ignore_all",
        method: 'POST',
    })
}